import CalendarWeekContainer from './CalendarWeekContainer';

export default CalendarWeekContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/CalendarWeek/index.js